import React, { createContext, useContext, useEffect, useReducer } from "react";
import { userDispatch } from "../../utils/localStorage";
import moment from "moment-timezone";

const initalState: any = {};

const UserContext = createContext<{
  data: any;
  dispatchData: React.Dispatch<any>;
}>({
  data: initalState,
  dispatchData: () => null,
});

const userDataDisptach = (state: any, data: any): any => {
  switch (data.case) {
    case "ADD":
      Object.keys(data?.payload).forEach((items) => {
        userDispatch({
          case: "ADD",
          key: items,
          payload: data?.payload[items],
        });
      });
      return { ...state, ...data.payload };
    case "UPDATE":
      return { ...state, ...data.payload };
    case "CLEAR":
      userDispatch({ case: "CLEAR" });
      return { ...initalState };
    default:
      return state;
  }
};

const UserContextProvider: React.FunctionComponent<any> = ({ children }) => {
  const [data, dispatchData] = useReducer(userDataDisptach, initalState);

  useEffect(() => {
    const keys = ["token", "user", "role", "timeZone", "cart"];
    keys.forEach((items) => {
      userDispatch({ case: "GET", key: items })?.then((__value) => {
        if (__value) {
          dispatchData({ case: "UPDATE", payload: { [items]: __value } });
        }
      });
    });
    userDispatch({ case: "ADD", key: "timeZone", payload: moment.tz.guess() });
  }, []);

  return (
    <UserContext.Provider value={{ data, dispatchData }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => {
  const userContext = useContext(UserContext);
  return userContext;
};

export default UserContextProvider;
